import { useEffect, useMemo, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
// import HomePageOne from "./pages/HomePageOne";
// import HomePageTwo from "./pages/HomePageTwo";
// import HomePageThree from "./pages/HomePageThree";
// import ShopPage from "./pages/ShopPage";
import ProductDetailsPageMain from "./pages/ProductDetailsPageMain";
// import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
// import ProductDetailsPageTwo from "./pages/ProductDetailsPageTwo";
import CartPageMain from "./pages/CartPageMain";
import CheckoutPage from "./pages/CheckoutPage";
import CheckoutPaymentPage from "./pages/CheckoutPaymentPage";
// import AccountPage from "./pages/AccountPage";
// import BlogPage from "./pages/BlogPage";
// import BlogDetailsPage from "./pages/BlogDetailsPage";
// import ContactPage from "./pages/ContactPage";
import PhosphorIconInit from "./helper/PhosphorIconInit";
// import VendorPage from "./pages/VendorPage";
// import VendorDetailsPage from "./pages/VendorDetailsPage";
// import VendorTwoPage from "./pages/VendorTwoPage";
// import VendorTwoDetailsPage from "./pages/VendorTwoDetailsPage";
// import BecomeSellerPage from "./pages/BecomeSellerPage";
// import WishlistPage from "./pages/WishlistPage";
import DashboardMain from "./pages/Dashboard";
import LoginPage from "./pages/Auth/LoginPage";
import RegistrationPage from "./pages/Auth/RegistrationPage";
import ProductCategorization from "./pages/ProductCategroization";
import ConfirmEmailPage from "./pages/Auth/ConfirmEmailPage";
//
import { useDispatch, useSelector } from "react-redux";
import { setGeolocation } from "./Features/system/systemSlice";
import { companyProfile } from "./Features/system/thunk";
import ProfilePage from "./pages/ProfilePage";
import AuthProtected from "./AuthProtected";
import { useGetTenants } from "./hooks/useAuth";
import Preloader from "./helper/Preloader";
import { setTenantId } from "./config";
import ForgotPasswordPage from "./pages/Auth/ForgotPasswordPage";
import ResetPasswordPage from "./pages/Auth/ResetPasswordPage";

function App() {
  const dispatch = useDispatch();
  const [appReady, setAppReady] = useState(false);

  // const [accountDeactivatedOpen, setAccountDeactivatedOpen] = useState(false);
  const {
    geolocation: { longitude, latitude },
  } = useSelector((state) => state.system);

  useEffect(() => {
    if (longitude && latitude) return;

    if (!("geolocation" in navigator)) {
      console.log("Geolocation is not available in this browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        dispatch(
          setGeolocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          }),
        );
      },
      (error) => {
        console.error("Error getting geolocation:", error);
      },
      {
        enableHighAccuracy: true,
        maximumAge: 0,
      },
    );
  }, [dispatch, longitude, latitude]);

  useEffect(() => {
    dispatch(companyProfile());
  }, [dispatch]);

  useEffect(() => {
    const favicon = document.querySelector('link[rel="shortcut icon"]');
    const companyLogo = document.querySelector("img.company_logo");
    const host = new URL(window.location.href)?.host ?? "";

    // averon.co.ke
    if (host === "averon.co.ke") {
      document.title =
        "Averon Pharmacy | Online Pharmaceutical Marketplace & Medicine Delivery";

      if (favicon) {
        favicon.href = `${process.env.PUBLIC_URL}/averon.ico`;
      }

      if (companyLogo) {
        companyLogo.src = `/assets/images/logo/averon.jpeg`;
      }
    } else {
      document.title =
        "phAMACart | Online Pharmaceutical Marketplace & Medicine Delivery";

      if (favicon) {
        favicon.href = `${process.env.PUBLIC_URL}/favicon.png`;
      }

      if (companyLogo) {
        companyLogo.src = `/assets/images/logo/makadara-chemist-logo.svg`;
      }
    }
  }, []);

  useEffect(() => {
    // run after app bootstrapping is done
    const init = async () => {
      // e.g. load config, check auth, wait for startup
      setAppReady(true);
    };

    init();
  }, []);

  const { data, isPending, isSuccess } = useGetTenants({
    enabled: appReady,
  });
  const tenants = useMemo(() => data?.data ?? data ?? [], [data]);

  useEffect(() => {
    if (isSuccess && tenants.length) {
      localStorage.setItem("tenants", JSON.stringify(tenants));

      const host = window.location.host;

      const tenant = tenants.find((tenant) => tenant.clientHost === host) ?? {
        id: "142771b0-fa00-4241-a165-e1741dbb3c74",
      };

      if (tenant) {
        setTenantId(tenant.id);
      }
    }
  }, [isSuccess, tenants]);

  if (isPending) return <Preloader />;

  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />

      <Routes>
        {/* <Route exact path='/' element={<HomePageOne />} /> */}
        {/*  */}
        <Route exact path="/" element={<DashboardMain />} />
        <Route
          exact
          path="/products/product-details/:id"
          element={<ProductDetailsPageMain />}
        />
        <Route
          exact
          path="/products/category"
          element={<ProductCategorization />}
        />
        <Route
          exact
          path="/products/prescription-products"
          element={
            <AuthProtected>
              <ProductCategorization />
            </AuthProtected>
          }
        />
        <Route
          exact
          path="/cart"
          // element={
          //   <AuthProtected>
          //     <CartPageMain />
          //   </AuthProtected>
          // }
          element={<CartPageMain />}
        />
        <Route
          exact
          path="/checkout"
          element={
            <AuthProtected>
              <CheckoutPage />
            </AuthProtected>
          }
        />
        <Route
          exact
          path="/checkout/payment"
          element={<CheckoutPaymentPage />}
        />
        <Route
          exact
          path="/profile"
          element={
            <AuthProtected>
              <ProfilePage />
            </AuthProtected>
          }
        />
        https://phamacoredev.co.ke:94/reset-password?userId=3de824c2-de3b-4d82-6357-08df0ce767f5&token=Q2ZESjhFeXRQbFBONHRSR25PcEJ4cnd5YS9VaUhiaElWZEZvSVVzRjR0N0lkV1dZaEkweGordk9CRWYwLyszeFg0bVdKbkdYTmR0ZUhlQlQ5WTNJdVVBVDQwODFjbndwUTZEbVlFNyt6YWN3RGZXMm1ZOFBGTjZsdEVlNzZaZW5mNTBYRlZsRFRDbmc4aStqRnpYeEFYV0k3MkNvQjF1akc5TnlUNmF6cHVQODA4RDNrd0tVOHN2NW9qeVZCRS8zK2VhRUNvVWU0bzV2Y0pySmRIRlhmcGVnZU5jVVdmV3NONkhISis2SnZpVm5hb3oz
        <Route exact path="/auth/login" element={<LoginPage />} />
        <Route exact path="/auth-register" element={<RegistrationPage />} />
        <Route exact path="/confirm-email" element={<ConfirmEmailPage />} />
        <Route exact path="/fogort-password" element={<ForgotPasswordPage />} />
        <Route exact path="/reset-password" element={<ResetPasswordPage />} />
        <Route exact path="*" element={<DashboardMain />} />
        {/*  */}
        {/* <Route
          exact
          path="/product-details"
          element={<ProductDetailsPageOne />}
        /> */}
        {/* <Route exact path="/index-two" element={<HomePageTwo />} />
        <Route exact path="/index-three" element={<HomePageThree />} />
        <Route exact path="/shop" element={<ShopPage />} />
        <Route
          exact
          path="/product-details-two"
          element={<ProductDetailsPageTwo />}
        />
        <Route exact path="/become-seller" element={<BecomeSellerPage />} />
        <Route exact path="/wishlist" element={<WishlistPage />} />
        <Route exact path="/account" element={<AccountPage />} />
        <Route exact path="/blog" element={<BlogPage />} />
        <Route exact path="/blog-details" element={<BlogDetailsPage />} />
        <Route exact path="/contact" element={<ContactPage />} />
        <Route exact path="/vendor" element={<VendorPage />} />
        <Route exact path="/vendor-details" element={<VendorDetailsPage />} />
        <Route exact path="/vendor-two" element={<VendorTwoPage />} />
        <Route
          exact
          path="/vendor-two-details"
          element={<VendorTwoDetailsPage />}
        /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
